import { YearMonthInput } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { FormInputProps } from '../types'

export const YearMonthFormInput: FunctionComponent<FormInputProps<string>> = ({
  validation,
  ...props
}) => {
  return (
    <YearMonthInput
      {...props}
      earliestYear={validation?._self?.minYear as number}
      monthsAhead={1}
    />
  )
}
